import { render, staticRenderFns } from "./Hover4.vue?vue&type=template&id=b72cf5b8&scoped=true"
import script from "./Hover4.vue?vue&type=script&lang=js"
export * from "./Hover4.vue?vue&type=script&lang=js"
import style0 from "./Hover4.vue?vue&type=style&index=0&id=b72cf5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72cf5b8",
  null
  
)

export default component.exports